export default __webpack_public_path__ + "static/Mandat_Stifani_Finanz_GmbH-bb798b743b0d716afa1476eb6f664e50.pdf";